import { ModelBase } from 'store/model-base';

export class CmsVideoResolution extends ModelBase {
    public static storeName: string = 'cmsVideoResolution';

    public title: string;
    public heading: string;
    public videoIcon: CmsMediaImage;
    public failureIcon: CmsMediaImage;
    public standardDefinition: VideoResoultionDefinition;
    public highDefinition: VideoResoultionDefinition;
    public standardDefinitionPhonePlansSeven: VideoResoultionDefinition;
    public highDefinitionPhonePlansSeven: VideoResoultionDefinition;
    public standardDefinitionTabletPlansSeven: VideoResoultionDefinition;
    public highDefinitionTabletPlansSeven: VideoResoultionDefinition;
    public sdMobileSelectPlansEight: VideoResoultionDefinition;
    public hdMobileSelectPlansEight: VideoResoultionDefinition;
    public sdMobilePlusPlansEight: VideoResoultionDefinition;
    public hdMobilePlusPlansEight: VideoResoultionDefinition;
    public progress: VideoResolutionPageDetails;
    public failure: VideoResolutionPageDetails;
    public pending: VideoResolutionPageDetails;
    public pendingDenialState: VideoResolutionPendingDenialState;
}
